<template>
    <div class="goBack iconfont icon-xitongfanhui" @click="goBack"></div>
</template>

<script>
export default {
    name: "GoBack",
    props: {
        linkTo: String,
    },
    methods: {
        goBack() {
            const THAT = this;
            let linkTo = THAT.linkTo || '/';
            THAT.$router.replace(linkTo);
        },
    },
};
</script>
<style lang='scss' scoped>
.goBack {
    position: fixed;
    top: 50px;
    left: 35px;
    z-index: 10000;
    width: 45px;
    height: 45px;
    font-size: 32px;
    line-height: 45px;
    text-align: center;
    color: #fff !important;
    cursor: pointer;
}

.goBack:hover {
    background-color: #f3f2f1;
    color: #000 !important;
}
</style>


// WEBPACK FOOTER //
// src/plugin/GoBack.vue